import React, { useRef, useState, useEffect } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import BootstrapButton from 'react-bootstrap/Button';
import { useFormContext } from 'react-hook-form';

import { OverlayTrigger, Tooltip } from "react-bootstrap";

/* Swiper */
import { Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

/* Organisms */
import Modal from 'js/components/organisms/Modal';

/* Config */
import { SWIPER_CONFIG } from 'js/config/swiper';

/* Symbols */
import chevronDownIcon from 'symbols/chevron-down.svg';
import arrowIcon from 'symbols/arrow.svg';
import { Icon } from 'js/components/atoms';

/* Symbols */
import toolTip from 'symbols/tooltip.svg';

/* Atoms */
import { Button } from 'js/components/atoms';

/* Utilities */
import { currency, trans, getImageFraction } from 'js/utilities';

export default function ConversionFlowFieldAccessories({ field, path, id, updateChoice }) {
    const { name, label, choices, config = {}, value: fieldValue } = field;
    const value = (fieldValue ?? []).filter(v => v != null);
    const { isDefaultOpen = false } = config;

    const visibleChoices = choices.filter(choice => !choice.hidden);

    const eventKey = name;
    const swiperRef = useRef();
    const sliderId = `carousel-${Math.floor(Math.random() * 1000000)}`;

    const [activeKey, setActiveKey] = useState(isDefaultOpen ? eventKey : null);
    const [showModal, setShowModal] = useState(false);
    const [selectedVariants, setSelectedVariants] = useState([]);

    const form = useFormContext();
    const {
        setValue = () => {},
        trigger = () => {},
    } = form || {};

    useEffect(() => {
        setValue(path, value);
    }, [value]);

    const isCurrentEventKey = activeKey === eventKey;

    const handleShowModal = (variants) => {
        setSelectedVariants(variants);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedVariants([]);
    };

    return (
        <div className="col-12">
            <Accordion activeKey={activeKey} onSelect={setActiveKey} bsPrefix="collapses">
                <div className={`collapse-item ${isCurrentEventKey ? 'collapse-show' : ''}`}>
                    <Accordion.Toggle
                        as={BootstrapButton}
                        variant="none"
                        className="btn--collapse justify-content-between btn-block"
                        eventKey={eventKey}
                        aria-expanded={isCurrentEventKey}
                        title={label}
                    >
                        <span className="h6 mb-0">
                            {label || 'Categorie'}
                        </span>
                        <div className="btn__icon">
                            <Icon url={chevronDownIcon.url} size={24} />
                        </div>
                    </Accordion.Toggle>

                    <Accordion.Collapse eventKey={eventKey}>
                        <div className="pt-4">
                            <Swiper
                                {...SWIPER_CONFIG}
                                id={sliderId}
                                ref={swiperRef}
                                modules={[Navigation, Pagination]}
                                navigation={{
                                    prevEl: `#${sliderId}-prev`,
                                    nextEl: `#${sliderId}-next`,
                                }}
                                pagination={false}
                                slidesPerView={1}
                                spaceBetween={5}
                                breakpoints={{
                                    768: {
                                        slidesPerView: 2,
                                        spaceBetween: 10,
                                    },
                                    992: {
                                        slidesPerView: 3,
                                        spaceBetween: 10,
                                    },
                                }}
                                noSwiping={true}
                                noSwipingClass="btn"
                                className="overflow-visible overflow-md-hidden"
                            >
                                {visibleChoices.map((choice, index) => {
                                    const isSelected = value.includes(choice.key);
                                    const hasVariantSelected = choice?.variants[0]?.some(variant => value.includes(variant.id));
                                    const isCardSelected = isSelected || hasVariantSelected;
                                    const image = choice?.image || '';
                                    const hasVariants = choice?.variants[0]?.length >= 1;

                                    return (
                                        <SwiperSlide key={choice.key}>
                                            <div className={`card card--bordered card--accessory h-100 d-flex flex-column justify-content-between ${isCardSelected ? 'card--selected' : ''}`}>
                                                <input
                                                    type="checkbox"
                                                    className="d-none"
                                                    id={`${id}.choices.${index}-${choice.key}`}
                                                    checked={isSelected}
                                                    readOnly={true}
                                                />
                                                <div
                                                    className="h-100 d-flex flex-column justify-content-between"
                                                    role={hasVariants ? undefined : "button"}
                                                    tabIndex={hasVariants ? undefined : 0}
                                                    onClick={hasVariants ? undefined : (e) => {
                                                        e.stopPropagation();

                                                        const checked = !isSelected;
                                                        const updated = checked
                                                            ? [...value, choice.key]
                                                            : value.filter((key) => key !== choice.key);

                                                        updateChoice(choice, checked, () => {
                                                            setValue(path, updated);
                                                            trigger(path);
                                                        });
                                                    }}
                                                >
                                                    {image && (
                                                        <OverlayTrigger
                                                            placement="top"
                                                            overlay={
                                                                <Tooltip className="mb-n2">
                                                                    {trans('product_detail.intro.fotos')}
                                                                </Tooltip>
                                                            }
                                                        >
                                                            <div className="d-flex btn--tooltip">
                                                                <Icon
                                                                    theme=""
                                                                    size={20}
                                                                    url={toolTip}
                                                                />
                                                            </div>
                                                        </OverlayTrigger>
                                                    )}
                                                    <div className="card__image position-relative">
                                                        {image && (
                                                            <img
                                                                {...getImageFraction({
                                                                    path: image,
                                                                    ratio: 3 / 2,
                                                                    fraction: 1,
                                                                    breakpoints: {
                                                                        md: { fraction: 1 / 2 },
                                                                        lg: { fraction: 1 / 3 },
                                                                    },
                                                                })}
                                                                alt={choice.label ? choice.label : choice.name}
                                                                className="img-fluid w-100 position-absolute"
                                                                loading="lazy"
                                                            />
                                                        )}
                                                        {choice?.options && Object.keys(choice.options).length > 0 &&
                                                            <span className="position-absolute alert alert-white text--12 py-1 px-2 mt-2 ml-2">{Object.values(choice.options)[0]}</span>
                                                        }
                                                    </div>
                                                    <div className="card-body p4 p-lg-8">
                                                        <span className="h6 card__title mb-2 text--18">{choice.label ? choice.label : choice.name}</span>
                                                        {!hasVariants ? (
                                                            <p className="card__subtitle text--14 text-muted--80 mb-2">
                                                                {choice?.number}
                                                            </p>
                                                        ) : null}
                                                        <p className="price mb-0 text-base font-weight-bold text--16 mt-auto">{choice?.variants[0]?.length >= 2 ? 'Vanaf ' : ''}{currency(choice.price)}</p>
                                                        <span className="text-muted--80 text--12">{trans('conversions.accessories.price.suffix')}</span>
                                                        {choice?.disclaimer &&
                                                            <span className="alert alert-grey text--12 py-1 px-2 mt-2 d-block">{choice.disclaimer}</span>
                                                        }
                                                    </div>
                                                    <div className="card-footer border-0 bg-transparent mt-auto px-4 px-lg-8 pb-4 pb-lg-8 pt-0">
                                                        {hasVariants ? (
                                                            <Button
                                                                type="button"
                                                                theme={choice.variants[0].some(variant => value.includes(variant.id)) ? 'callout' : 'outline-callout'}
                                                                text={choice.variants[0].some(variant => value.includes(variant.id)) ? 'Gekozen' : 'Varianten'}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    handleShowModal(choice.variants[0]);
                                                                }}
                                                            />
                                                        ) : (
                                                            <Button
                                                                type="button"
                                                                theme={isSelected ? 'callout' : 'outline-callout'}
                                                                text={isSelected ? 'Gekozen' : 'Kiezen'}
                                                            />
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </SwiperSlide>
                                    );
                                })}
                            </Swiper>
                            <div id={`${sliderId}-prev`} className="swiper-button-prev">
                                <Icon url={arrowIcon} size={24} />
                            </div>
                            <div id={`${sliderId}-next`} className="swiper-button-next">
                                <Icon url={arrowIcon} size={24} />
                            </div>
                        </div>
                    </Accordion.Collapse>
                </div>
            </Accordion>

            <Modal
                className=""
                open={showModal}
                handleClose={handleCloseModal}
                title={'Product varianten'}
                bootstrapFooter={
                    <div>
                        <Button
                            type="button"
                            theme="callout"
                            text="Sluiten"
                            className="btn-block"
                            onClick={handleCloseModal}
                        />
                    </div>
                }
            >

                <div className="position-relative">
                    <Swiper
                        {...SWIPER_CONFIG}
                        id={`${sliderId}-modal`}
                        modules={[Navigation, Pagination]}
                        navigation={{
                            prevEl: `#${sliderId}-modal-prev`,
                            nextEl: `#${sliderId}-modal-next`,
                        }}
                        pagination={false}
                        slidesPerView={1}
                        spaceBetween={5}
                        breakpoints={{
                            768: {
                                slidesPerView: 2,
                                spaceBetween: 10,
                            }
                        }}
                        noSwiping={true}
                        noSwipingClass="btn"
                        className="overflow-visible overflow-md-hidden"
                    >
                        {selectedVariants.map((variant, index) => {
                            const isSelectedVariant = value.includes(variant.id);
                            const image = variant?.image || '';

                            return (
                                <SwiperSlide key={variant.id || index}>
                                    <div className={`card card--bordered card--accessory h-100 d-flex flex-column justify-content-between ${isSelectedVariant ? 'card--selected' : ''}`}>
                                        <input
                                            type="checkbox"
                                            className="d-none"
                                            id={`modal-${id}.choices.${index}-${variant.id}`}
                                            checked={isSelectedVariant}
                                            readOnly={true}
                                        />
                                        <div
                                            className="h-100 d-flex flex-column justify-content-between"
                                            role="button"
                                            tabIndex={0}
                                            onClick={(e) => {
                                                e.stopPropagation();

                                                const checked = !isSelectedVariant;
                                                const updated = checked
                                                    ? [...value, variant.id]
                                                    : value.filter((id) => id !== variant.id);


                                                updateChoice({ ...variant, key: variant.id }, checked, () => {
                                                    setValue(path, updated);
                                                    trigger(path);
                                                });
                                            }}
                                        >
                                            {image && (
                                                <OverlayTrigger
                                                    placement="top"
                                                    overlay={
                                                        <Tooltip className="mb-n2">
                                                            {trans('product_detail.intro.fotos')}
                                                        </Tooltip>
                                                    }
                                                >
                                                    <div className="d-flex btn--tooltip">
                                                        <Icon
                                                            theme=""
                                                            size={20}
                                                            url={toolTip}
                                                        />
                                                    </div>
                                                </OverlayTrigger>
                                            )}
                                            <div className="card__image position-relative">
                                                {image && (
                                                    <img
                                                        {...getImageFraction({
                                                            path: image,
                                                            ratio: 3 / 2,
                                                            fraction: 1,
                                                            breakpoints: {
                                                                md: { fraction: 1 / 2 },
                                                            },
                                                        })}
                                                        alt={variant.label ? variant.label : variant.name}
                                                        className="img-fluid w-100 position-absolute"
                                                        loading="lazy"
                                                    />
                                                )}
                                                {variant?.options && Object.keys(variant.options).length > 0 &&
                                                    <span className="position-absolute alert alert-white text--12 py-1 px-2 mt-2 ml-2">{Object.values(variant.options)[0]}</span>
                                                }
                                            </div>
                                            <div className="card-body p4 p-lg-8">
                                                <span className="h6 card__title mb-2 text--18">{variant.label ? variant.label : variant.name}</span>
                                                <p className="card__subtitle text--14 text-muted--80 mb-2">
                                                    {variant?.number}
                                                </p>
                                                <p className="price mb-0 text-base font-weight-bold text--16">{currency(variant.price)}</p>
                                                <span className="text-muted--80 text--12">{trans('conversions.accessories.price.suffix')}</span>
                                                {variant?.disclaimer &&
                                                    <span className="alert alert-grey text--12 py-1 px-2 mt-2 d-block">{variant.disclaimer}</span>
                                                }
                                            </div>
                                            <div className="card-footer border-0 bg-transparent mt-auto px-4 px-lg-8 pb-4 pb-lg-8 pt-0">
                                                <Button
                                                    type="button"
                                                    theme={isSelectedVariant ? 'callout' : 'outline-callout'}
                                                    text={isSelectedVariant ? 'Gekozen' : 'Kiezen'}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            );
                        })}
                    </Swiper>
                    <div id={`${sliderId}-modal-prev`} className="swiper-button-prev">
                        <Icon url={arrowIcon} size={24} />
                    </div>
                    <div id={`${sliderId}-modal-next`} className="swiper-button-next">
                        <Icon url={arrowIcon} size={24} />
                    </div>
                </div>
            </Modal>
        </div>
    );
}
